<template xmlns="http://www.w3.org/1999/html">
  <div class="container p-0">

    <FullScreenLoader v-if="!active" />

    <div class="main-home-container" v-else>
      <PreLiveShop v-if="active == 1" :date="fecha" :urlImgPC="urlImgPrePC" :urlImgMO="urlImgPreMO" />
      <PostLiveShop v-if="active == 2" :urlImgPC="urlImgPostPC" :urlImgMO="urlImgPostMO" :urlReplayYT="urlReplay" />
      <LiveShop v-if="active == 3" />
      <!-- <Footer v-if="footer && active != 3"/> -->
    </div>

  </div>

</template>

<script>
import fire from "./../fire";
import firebase from "firebase";
import Tips from "../components/Tips";
import Footer from "../components/Footer";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import PreLiveShop from "../components/PreLiveShop";
import PostLiveShop from "../components/PostLiveShop";
import LiveShop from '../components/LiveShop';
import moment from "moment-timezone";
import FullScreenLoader from "../components/FullScreenLoader.vue";
Vue.use(VueSweetalert2);

export default {
  name: "Home",
  components: { Tips, Footer, VueSlickCarousel, PostLiveShop, PreLiveShop, LiveShop, FullScreenLoader },
  data() {
    return {
      ancho: 0,
      origen: false,
      showmodal: false,
      modalvideo: false,
      ofertas: false,
      contador: true,
      chatvisible: true,
      bannerContador: false,
      chat: false,
      videoUrl: '',
      verVideo: false,
      overlay: false,
      suscripcion: false,
      titulo: '',
      descripcion: '',
      fecha: new Date("2023/04/13 20:00:00"),
      modalData: [],
      config: [],
      sentimientos: [],
      numerolike: 0,
      likes: false,
      active: '',
      renderComponent: true,
      footer: false,
      debug: '',
      urlImgPostPC: '',
      urlImgPostMO: '',
      urlImgPrePC: '',
      urlImgPreMO: '',
      urlReplay: '',
      settings: {
        "dots": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": true
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2,
              "initialSlide": 2
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      }
    }

  },
  methods: {
    cerrar() {
      this.showmodal = false;
      this.overlay = false;
    },
    chathidden() {
      this.chatvisible = !this.chatvisible
    },
    mostrarModal(data) {
      if (data.url) {
        window.open(data.url, '_blank').focus();
      } else {
        this.modalData = data;
        this.showmodal = true;
        this.overlay = true;
      }
    },
    checkCurrentTime() {
      let now = new Date();
      if (now > this.fecha) {
        //this.chat = true;
      }
    },
    startFCM() {
      firebase.analytics().logEvent('boton_suscribirse');
      if (firebase.messaging.isSupported()) {
        const messaging = fire.messaging();
        //Notification.requestPermission()
        messaging.requestPermission()
          .then(function () {
            console.log('Notification permission granted.');
            return messaging.getToken()
          })
          .then(function (result) {
            console.log("The token is: ", result);
            Vue.swal.fire({
              title: "Suscripción Samsung Liveshop Neo Qled",
              html: 'Gracias por suscribirte, te notificaremos cuando comience el evento',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
                text: 'mensajeSweet'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              showCloseButton: true,
              confirmButtonText: 'Aceptar'
            })

          })
          .catch(function (err) {
            console.log('Unable to get permission to notify.', err);
            Vue.swal.fire({
              title: "Suscripción Samsung Liveshop Neo Qled",
              html: 'Debes aceptar recibir notificaciones en tu navegador',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
                text: 'mensajeSweet'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              showCloseButton: true,
              confirmButtonText: 'Aceptar'
            })
          });
      } else {
        Vue.swal("Tu navegador no soporta notificaciones, utiliza Chrome para esta funcionalidad");
      }
    },
    newsLetter() {
      firebase.analytics().logEvent('boton_newsletter');
    },
    getCalendarEvent() {
      let eventDate = moment(this.fecha).format('yyyy-MM-DD hh:mm a');
      let endDate = moment(eventDate, 'yyyy-MM-DD hh:mm a').add(45, 'minutes').format('yyyy-MM-DD hh:mm a');
      if (navigator.userAgent.indexOf("Win") != -1 || navigator.userAgent.indexOf("Android") != -1) {
        const a = document.createElement('a')
        a.href = 'https://calndr.link/d/event/?service=google&start=' + eventDate + '&end=' + endDate + '&title=' + this.titulo + '&timezone=America/Santiago&description=' + this.descripcion + '&location=https://shop.samsung.cl/live'
        // a.href = 'https://www.google.com/calendar/render?action=TEMPLATE&text=Liveshop+Galaxy+Book2&details=Te+invitamos+a+participar+del+Liveshop+de+Galaxy+Book2&location=https%3A%2F%2Fshop.samsung.cl%2Flive&dates=20220512T010000Z%2F20220512T014500Z'
        a.target = '_blank';
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        const a = document.createElement('a')
        // a.href = 'liveshop.ics'
        a.href = 'https://calndr.link/d/event/?service=apple&start=' + eventDate + '&end=' + endDate + '&title=' + this.titulo + '&timezone=America/Santiago&description=' + this.descripcion + '&location=https://shop.samsung.cl/live'
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  },
  mounted() {
    this.debug = this.$route.query.debug
    this.ancho = screen.width;
    let ref = this;
    const itemsRef = fire.database().ref("config");
    // console.log(itemsRef);
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      // console.log(data);
      if (data.chat === true) {
        ref.chat = true;
      } else {
        ref.chat = false;
      }

      if (data.verVideo === true) {
        ref.verVideo = true;
      } else {
        ref.verVideo = false;
      }


      ref.videoUrl = data.video;
      ref.videoMobile = data.videoMobile;
      ref.titulo = data.titulo;
      ref.contador = data.contador;
      ref.bannerContador = data.bannerContador;
      ref.fecha = data.fecha;
      ref.likes = data.likes;
      ref.suscripcion = data.suscripcion;
      ref.urlImgPostPC = data.urlImgPostPC;
      ref.urlImgPostMO = data.urlImgPostMO;
      ref.urlImgPrePC = data.urlImgPrePC;
      ref.urlImgPreMO = data.urlImgPreMO;
      ref.urlReplay = data.urlReplay;

      if (this.debug) {
        ref.active = this.debug
      } else {
        ref.active = data.active;
      }
      ref.footer = data.footer;
    });
    window.scrollTo(0, 0);
  },
  created() {
    if (this.$route.query.origen) {
      this.origen = true;
    }
    // this.displayMessage();
    window.scrollTo(0, 0);
  },
  watch: {
    videoUrl: function () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    }
  }
};
</script>

<style lang="scss"></style>
